/**
 * Helper function to resolve image URLs
 * Converts placeholder paths like "@src/shared/assets/images/..." to actual asset paths
 */
export function resolveImageUrl(url: string): string {
  // If it's already a full URL (http/https), return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a placeholder path starting with @src/, convert to actual path
  if (url.startsWith('@src/')) {
    // Remove @src/ prefix - Vite serves files from src/ directory
    // In dev: /src/shared/assets/images/... works
    // In production, assets should be imported or in public folder
    return url.replace('@src/', '/src/');
  }
  
  // If it starts with /, it's already an absolute path
  if (url.startsWith('/')) {
    return url;
  }
  
  // Return as is if it's already a valid path
  return url;
}

